import { message, Row } from "antd"
import { Button, Checkbox } from "components/common"
import { notification } from "components/common/notification/Notification"
import React, { useState } from "react"
import { useDispatch } from "react-redux"
import { callPutApiWithAuth } from "utils/api"
import { saveStorage } from "utils/auth"
import { useHistory } from "react-router-dom";

export default function UpgradeAccountPage() {

    const [isChecked, setIsChecked] = useState(false)
    const [isUpgrading, setIsUpgrading] = useState(false)
    const dispatch = useDispatch()
    const history = useHistory();

    const onSuccessUpgrade = ({ data }) => {
        setIsUpgrading(false)
        message.success({
            message: "Success",
            description: "Upgraded successfully."
        })
        saveStorage(data.user, data.token)
        dispatch({ type: "auth.SET_LOGGED_IN", payload: { user: data.user } })

        window.open(`/login?auto-token-login&token=${data.token}`, '_self')

        history.push("/")
    }

    const onFailedUpgrade = (err) => {
        setIsUpgrading(false)
        message.error({
            message: "Failed",
            description: err
        })
    }

    const handleUpgradeAccount = () => {
        if(!isChecked) {
            message.error({
                message: "Error",
                description: "Please agree to the Social Marketer Policies and Procedures."
            })
            return
        }
        setIsUpgrading(true)
        callPutApiWithAuth("my_account/setting/change_type", { type: 1 }, onSuccessUpgrade, onFailedUpgrade)
    }

    return <div>
        <Row style={{ margin: "20px 0px" }}>
            <Checkbox label={<>I agree to the <a href="https://nuevalife.com/policies-and-procedures" target="_blank" rel="noopener noreferrer">Social Marketer Policies and Procedures</a></>} checked={isChecked} onChange={() => { setIsChecked(!isChecked) }} />
        </Row>
        <Row>
            <Button onClick={handleUpgradeAccount} disabled={!isChecked}>Become a Social Marketer</Button>
        </Row>
    </div>
}